import {
	LOGIN_USER,
	LOGIN_USER_SUCCESS,
	LOGOUT_USER,
	AUTH_ERROR
} from '../actionTypes';

const initialState = {
	error: '',
	loading: false,
	user: null
};

const login = (state = initialState, action) => {
	switch (action.type) {
		case LOGIN_USER:
			state = {
				...state,
				loading: true,
				error: ''
			};
			break;
		case LOGIN_USER_SUCCESS:
			state = {
				...state,
				loading: false,
				user: action.payload,
				error: ''
			};
			break;
		case LOGOUT_USER:
			state = { ...state, error: '', user: null };
			break;
		case AUTH_ERROR:
			state = { ...state, error: action.payload, loading: false };
			break;
		default:
			state = { ...state };
			break;
	}
	return state;
};

export default login;
